module.exports = __webpack_public_path__ + "img/ម៉ាសុីនហ្គេម.9141c354.png";